<template>
  <ModalDialog header-text="Confirmation" @closeModal="closeModal" open>
    <template v-slot:content>
      <div class="visit-confirmation-content">
        <p>Continue and submit this report for:</p>

        <div class="visit-inspection-form__visit-row">
          <label>
            <b>Company Name{{ otherCompaniesData.length > 1 ? "s" : "" }}:</b>
          </label>
          <ul style="list-style: none; padding-left: 0; margin: 0">
            <li
              v-for="company in otherCompaniesData"
              :key="company.CompanyId"
              style="display: flex; align-items: center; gap: 6px"
            >
              {{ company.Name }} <span class="plant-status">[{{ company.PlantStatus }}]</span>
              <BadgeIndicator
                v-if="company.GroupStatus === 'Main' && otherCompaniesData.length > 1"
                text="Main"
                type="info"
              />
            </li>
          </ul>
        </div>

        <div class="visit-inspection-form__visit-row"><b>Plant Name:</b> {{ formData.plantName }}</div>
        <div v-if="visitId" class="visit-inspection-form__visit-row"><b>Visit ID:</b> {{ visitId }}</div>
        <div class="visit-inspection-form__visit-row"><b>Visit Type:</b> {{ formData.visitType?.text }}</div>
        <div class="visit-inspection-form__visit-row"><b>RC Name:</b> {{ formData.rcName }}</div>
        <div class="visit-inspection-form__visit-row">
          <b>Visit Date:</b>
          {{ moment(formData.visitDate).format("MM/DD/yyyy") }}
        </div>
        <p v-if="hasFilledHiddenAnnualQuestions" class="visit-confirmation-content__annual-warning">
          Warning: Annual questions are currently hidden and will not be submitted.
        </p>
        <div class="visit-confirmation-content__actions">
          <Button class="visit-confirmation-content__confirm" type="button" themeColor="primary" @click="confirm"
            >Confirm</Button
          >
          <Button class="visit-confirmation-content__cancel" type="button" themeColor="secondary" @click="closeModal"
            >Cancel</Button
          >
        </div>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { Button } from "@progress/kendo-vue-buttons";
import BadgeIndicator from "@/shared/ui/BadgeIndicator.vue";
import type { FormData } from "@/stores/useInspectionStore";
import moment from "moment";
import type { InspectionVisitOtherCompany } from "@/Domain/InspectionVisitOtherCompany";

const emit = defineEmits<{
  (e: "closeModal"): void;
  (e: "confirm"): void;
}>();

const props = defineProps<{
  formData: FormData;
  otherCompaniesData: InspectionVisitOtherCompany[];
  visitId?: string;
  hasFilledHiddenAnnualQuestions?: boolean;
}>();

const closeModal = function () {
  emit("closeModal");
};

const confirm = function () {
  emit("confirm");
};
</script>

<style lang="scss">
.visit-confirmation-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 600px;

  &__actions {
    display: flex;
    gap: 20px;
    margin: 0 auto;
    padding: 6px;
  }

  &__confirm {
    width: 100px;
  }

  &__cancel {
    width: 100px;
  }

  .plant-status {
    font-weight: bold;
  }

  &__annual-warning {
    color: #b94a00;
    font-weight: bold;
  }
}
</style>
